module.exports = __webpack_public_path__ + "static/media/waveform.b42cec0c.svg";